module.exports = __webpack_public_path__ + "img/undraw_folder_files_red.759fb123.svg";